import { useCallback, useEffect, useState } from "react";
import { type Notification, notificationsApi } from "../../lib/api/notifications.js";
import { travelApi } from "../../lib/api/travel.js";
import "./Notifications.css";

function plus30Days(): string {
  const d = new Date();
  d.setUTCDate(d.getUTCDate() + 30);
  return d.toISOString().slice(0, 10);
}

const ICON: Record<string, string> = {
  connection_request: "👋",
  connection_accepted: "🤝",
  still_here: "📍",
  arriving_in_your_city: "✈️",
};

export function Notifications() {
  const [items, setItems] = useState<Notification[]>([]);
  const [busy, setBusy] = useState<string | null>(null);

  const load = useCallback(() => {
    notificationsApi.list().then((r) => setItems(r.success && r.data ? r.data.notifications : []));
  }, []);
  useEffect(() => load(), [load]);

  async function confirm(n: Notification, extend: boolean) {
    if (!n.entry_id) return;
    setBusy(n.id);
    await travelApi.confirm(n.entry_id, extend ? plus30Days() : undefined);
    await notificationsApi.markRead(n.id);
    setBusy(null);
    load();
  }

  async function markAll() {
    await notificationsApi.markAllRead();
    load();
  }

  return (
    <section className="ntf">
      <div className="ntf__head">
        <h1 className="ntf__h1">Notifications</h1>
        {items.some((n) => !n.read_at) && (
          <button type="button" className="ntf__all" onClick={markAll}>
            Mark all read
          </button>
        )}
      </div>

      {items.length === 0 && <p className="ntf__muted">You're all caught up.</p>}

      <ul className="ntf__list">
        {items.map((n) => (
          <li key={n.id} className={`ntf__item${n.read_at ? "" : " is-unread"}`}>
            <span className="ntf__icon" aria-hidden="true">
              {ICON[n.kind] ?? "•"}
            </span>
            <div className="ntf__body">
              <span>{n.body ?? n.kind}</span>
              {n.kind === "still_here" && n.entry_id && (
                <div className="ntf__actions">
                  <button
                    type="button"
                    className="btn btn-primary ntf__btn"
                    disabled={busy === n.id}
                    onClick={() => confirm(n, true)}
                  >
                    Still here
                  </button>
                  <button
                    type="button"
                    className="ntf__btn ntf__btn-ghost"
                    disabled={busy === n.id}
                    onClick={() => confirm(n, false)}
                  >
                    I'm back
                  </button>
                </div>
              )}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
